/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit ButtonIconLabel/view.blocks to change it.
import Children from 'Simple/Children'
import Label from 'DesignSystem/Label/index'
import React from 'react'
import styles from './view.module.css'
import useIsHovered from 'Simple/hooks/useIsHovered'



/** @type {import('Simple/types.js').View} */
export default function ButtonIconLabel({
  children,
  viewPath = "/DesignSystem/ButtonIconLabel",
  borderBottomLeftRadius = 6,
  borderBottomRightRadius = 6,
  borderTopLeftRadius = 6,
  borderTopRightRadius = 6,
  marginTop = 0,
  marginRight = 0,
  marginLeft = 0,
  marginBottom = 0,
  onClick,
  goTo,
  target = "_blank",
  isDisabled,
  paddingTop = 8,
  paddingLeft = 8,
  paddingBottom = 8,
  paddingRight = 8,
  opacity = 1,
  width = "auto",
  justifyContent = "flex-start",
  isSelected,
  text = "New",
  color = "#606060",
  fontSize = 10,
  maxWidth = 190,
  fontWeight = 400,
  textTransform = "uppercase"
  
}) {
let [isHovered, isSelectedHovered, isHoveredBind] = useIsHovered({isDisabled,isSelected})
  return (<React.Fragment
>
<a
 href={goTo} rel='noopener noreferrer' target='_blank'
  data-testid="ButtonIconLabel.Horizontal"
  data-view-path={viewPath}
 {...isHoveredBind}
 onClick={onClick}
 target={target}
 disabled={isDisabled}
 style={{'--bblr-3-Z1UwaTt': typeof borderBottomLeftRadius === 'number' ? `${borderBottomLeftRadius}px` : borderBottomLeftRadius,'--bbrr-4-Z1UwaTt': typeof borderBottomRightRadius === 'number' ? `${borderBottomRightRadius}px` : borderBottomRightRadius,'--btlr-5-Z1UwaTt': typeof borderTopLeftRadius === 'number' ? `${borderTopLeftRadius}px` : borderTopLeftRadius,'--btrr-6-Z1UwaTt': typeof borderTopRightRadius === 'number' ? `${borderTopRightRadius}px` : borderTopRightRadius,'--mt-7-Z1UwaTt': typeof marginTop === 'number' ? `${marginTop}px` : marginTop,'--mr-8-Z1UwaTt': typeof marginRight === 'number' ? `${marginRight}px` : marginRight,'--ml-9-Z1UwaTt': typeof marginLeft === 'number' ? `${marginLeft}px` : marginLeft,'--mb-10-Z1UwaTt': typeof marginBottom === 'number' ? `${marginBottom}px` : marginBottom,'--pt-11-Z1UwaTt': typeof paddingTop === 'number' ? `${paddingTop}px` : paddingTop,'--pl-12-Z1UwaTt': typeof paddingLeft === 'number' ? `${paddingLeft}px` : paddingLeft,'--pb-13-Z1UwaTt': typeof paddingBottom === 'number' ? `${paddingBottom}px` : paddingBottom,'--pr-14-Z1UwaTt': typeof paddingRight === 'number' ? `${paddingRight}px` : paddingRight,'--o-15-Z1UwaTt': opacity,'--w-16-Z1UwaTt': typeof width === 'number' ? `${width}px` : width,'--jc-17-Z1UwaTt': justifyContent,'--bc-2-Z1UwaTt': isSelected ? "rgba(0,188,112, 0.1)" : isHovered ? "rgba(111,111,111, 0.1)" : "transparent",'--bc-1-Z1UwaTt': isSelected ? "#00BC70" : "transparent"}}
 className={`views-block ${styles.Horizontal}`}
>
<Children
  viewPath={`${viewPath}/Children`}
 isSelected={isSelected} isHovered={isHovered} isSelectedHovered={isSelectedHovered}
>
{children}
</Children>
<Label
  viewPath={`${viewPath}/Label`}
 text={text}
 marginLeft={8}
 color={isSelected ? "rgba(0,188,112, 1)" : color}
 marginBottom={0}
 marginTop={1}
 fontSize={fontSize}
 maxWidth={maxWidth}
 fontWeight={fontWeight}
 textTransform={textTransform}
/>
</a>
</React.Fragment>)
}